import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import Reveal from "@/components/Reveal";
import VentureCard from "@/components/public/VentureCard";

const FILTERS = ["All", "Active", "In Development", "Future Venture"];

export default function Ventures() {
  const [ventures, setVentures] = useState([]);
  const [filter, setFilter] = useState("All");

  useEffect(() => {
    api.get("/ventures").then(({ data }) => setVentures(data)).catch(() => {});
  }, []);

  const filtered = filter === "All" ? ventures : ventures.filter((v) => v.status === filter);

  return (
    <div data-testid="page-ventures" className="bg-bd-charcoal min-h-screen">
      <section className="pt-40 pb-16 md:pb-24 bg-bd-black grain relative">
        <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10">
          <Reveal>
            <p className="overline text-bd-gold mb-6">The Portfolio</p>
            <h1 className="font-serif text-4xl md:text-7xl text-bd-ivory leading-[1.05] max-w-4xl">
              Ventures across industries, built to endure
            </h1>
            <p className="mt-8 text-base md:text-lg text-bd-ivory/60 max-w-2xl leading-relaxed">
              Each business in the Black Diamond ecosystem is developed with intent — from active operations to ventures in development and those on the horizon.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="flex flex-wrap gap-3 mb-12">
            {FILTERS.map((f) => (
              <button
                key={f}
                data-testid={`venture-filter-${f.toLowerCase().replace(/\s+/g, "-")}`}
                onClick={() => setFilter(f)}
                className={`px-5 py-2 text-xs tracking-[0.15em] uppercase border transition-colors duration-300 ${
                  filter === f ? "border-bd-gold text-bd-gold bg-bd-gold/5" : "border-white/15 text-bd-ivory/50 hover:text-bd-ivory hover:border-white/40"
                }`}
              >
                {f}
              </button>
            ))}
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {filtered.map((v, i) => (
              <Reveal key={v.id} delay={(i % 3) * 0.06}><VentureCard venture={v} index={i} /></Reveal>
            ))}
          </div>
          {filtered.length === 0 && (
            <p className="text-bd-ivory/40 py-20 text-center">No ventures in this category yet.</p>
          )}
        </div>
      </section>
    </div>
  );
}
